// avcraft-shaped mock for the Roadmap tab (Phase 4.2, mock-first). Mirrors the
// design reference's Flightpath data. Real data comes from GET /roadmap (adapter
// over today's Jira) once deployed.
import type { RoadmapView } from "../../../lib/brain-api";

export const mockRoadmapView: RoadmapView = {
  customerId: "avcraft",
  counts: { total: 10, awaitingDecision: 2, oldestAwaitingDays: 12, fastTracked: 1, onRoadmap: 2, delivered: 2 },
  requests: [
    // REQUESTED
    { key: "TICKET-23010", title: "COP on parts-issue screen", stage: "requested", votes: 3, daysInStage: 9, derived: [] },
    { key: "TICKET-23011", title: "Bulk re-date logbook entries", stage: "requested", daysInStage: 21, derived: ["stage"] },
    // AT ORDER DESK (matched to decisionQueue by key)
    { key: "TICKET-22454", title: "Auto-add tasks to workpack", stage: "order-desk", votes: 2, daysInStage: 12, derived: [] },
    { key: "TICKET-23001", title: "Inline PDF preview for TDs", stage: "order-desk", daysInStage: 4, derived: [] },
    // IN A LANE
    { key: "TICKET-22990", title: "Aeronet TDs export to XLS", stage: "laned", lane: "roadmap", votes: 4, daysInStage: 6, derived: [] },
    { key: "TICKET-22991", title: "PO approval routing rules", stage: "laned", lane: "charter", daysInStage: 15, derived: ["lane"] },
    // ON THE TRAIN · 4.16
    { key: "TICKET-22880", title: "Configurable PO approval workflow", stage: "on-train", lane: "fast-track", votes: 6, fixVersion: "4.16", shipDate: "22 Sep", daysInStage: 3, hero: true, derived: [] },
    { key: "TICKET-22803", title: "Garmin limitation dropdown cleanup", stage: "on-train", lane: "roadmap", votes: 5, fixVersion: "4.16", shipDate: "22 Sep", daysInStage: 8, derived: [] },
    // DELIVERED
    { key: "TICKET-22701", title: "Engineer work report v2", stage: "delivered", fixVersion: "4.15", daysInStage: 0, derived: [] },
    { key: "TICKET-22550", title: "Quality register bulk export", stage: "delivered", fixVersion: "4.14", daysInStage: 0, derived: [] },
  ],
  decisionQueue: [
    { key: "TICKET-22454", title: "Auto-add tasks to workpack", lanesOffered: ["Fast-track quote", "Wait for roadmap"], daysSinceLetter: 12 },
    { key: "TICKET-23001", title: "Inline PDF preview for TDs", lanesOffered: ["Roadmap (free)", "Fast-track"], daysSinceLetter: 4 },
  ],
  signals: [
    { text: "AvCraft's asks cluster around workflow automation (PO, workpack) and reporting — consistent with their stock-quality drive.", refs: [] },
    { text: "Merge candidates — 2 requests map to modules already porting to 4.16: [ref:ticket:TICKET-22880] and [ref:ticket:TICKET-22454].", refs: ["ticket:TICKET-22880", "ticket:TICKET-22454"] },
    { text: "Bridging needed — “COP on parts-issue screen” lives in the [ref:visit:avcraft/2026-07-02] action register with no ticket yet.", refs: ["visit:avcraft/2026-07-02"] },
  ],
};
